import { alias, custom, identifier, serializable, serialize, SKIP } from "serializr";

import dayjs from "@/common/utils/dayjs";

export abstract class Base {
  @serializable(identifier())
  public id: number;

  @serializable(
    alias(
      "createdDate",
      custom(
        () => SKIP,
        (v) => {
          if (v) return dayjs(v);
          return undefined;
        },
      ),
    ),
  )
  public createdAt: Date;

  @serializable(
    alias(
      "updatedDate",
      custom(
        () => SKIP,
        (v) => {
          if (v) return dayjs(v);
          return undefined;
        },
      ),
    ),
  )
  public updatedAt: Date;

  // For autocomplete
  public name: string;
  public disabled: boolean;

  public serialize(): any {
    return serialize(this);
  }
}
